import React, { useEffect, useState, useContext } from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import shortid from "shortid";

import { GOOGLE_CLOUD_API_KEY, DEFAULT_MAP_POSITION } from "../../../../../utils/generalData";
import { ManageLoadPostContext } from "../..";

var userMarker = null;

const OriginDestinationSelectionMap = ({ isForUpdate }) => {
  const google = window.google;
  const [map, setMap] = useState();
  const [mapRef, setMapRef] = useState(undefined);

  const [totalDistance, setTotalDistance] = useState(null);
  const [mapSelectionStart, setMapSelectionStart] = useState(false);

  const [currentLocation, setCurrentLocation] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);

  const [directionsService, setDirectionsService] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);

  const [loadPostState, loadPostContextDispatch] = useContext(
    ManageLoadPostContext
  );
  const loadPostInfo = loadPostState?.loadPostInfo;
  const errorMessages = loadPostState.loadPostInfoErrors;


  const getGeoLocation = (map) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        var myLatLng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        currentLocation === null && setCurrentLocation(myLatLng);

        userMarker = new google.maps.Marker({
          position: myLatLng,
          map,
          draggable: true,
          label: "A",
        });

        if (!isForUpdate) {
          loadPostContextDispatch({
            type: "ON_CHANGE_LOAD_POST_INFO",
            payload: {
              name: "origin_latitude",
              value: position.coords.latitude,
            },
          });
          loadPostContextDispatch({
            type: "ON_CHANGE_LOAD_POST_INFO",
            payload: {
              name: "origin_longitude",
              value: position.coords.longitude,
            },
          });
        }
      });
    }
  };

  useEffect(() => {
    map && getGeoLocation(map);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);


  useEffect(() => {
    if(userMarker){
      google.maps.event.addListener(userMarker, 'dragend', function (event) {
        setCurrentLocation({
          lat: this.getPosition().lat(),
          lng : this.getPosition().lng()
        });

        loadPostContextDispatch({
          type: "ON_CHANGE_LOAD_POST_INFO",
          payload: {
            name: "origin_latitude",
            value: this.getPosition().lat(),
          },
        });
        loadPostContextDispatch({
          type: "ON_CHANGE_LOAD_POST_INFO",
          payload: {
            name: "origin_longitude",
            value: this.getPosition().lng(),
          },
        });
      });
    }
  }, [userMarker]);


  const originDrugChanged = (event) => {
    loadPostContextDispatch({
      type: "ON_CHANGE_LOAD_POST_INFO",
      payload: {
        name: "origin_latitude",
        value: event.lat(),
      },
    });
    loadPostContextDispatch({
      type: "ON_CHANGE_LOAD_POST_INFO",
      payload: {
        name: "origin_longitude",
        value: event.lng(),
      },
    });
  };


  const handleDestinationClick = (event) => {
    loadPostContextDispatch({
      type: "ON_CHANGE_LOAD_POST_INFO",
      payload: {
        name: "destination_latitude",
        value: event.lat(),
      },
    });
    loadPostContextDispatch({
      type: "ON_CHANGE_LOAD_POST_INFO",
      payload: {
        name: "destination_longitude",
        value: event.lng(),
      },
    });
  };


  // Show or hide error messages on mouse enter or leave
  const showErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "true");
  const hideErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "false");


  const directionsCallback = (response) => {
    if (response !== null) {
      if (response.status === "OK") {
        setDirectionsResponse(response);

        loadPostContextDispatch({
          type: "SET_ADDRESS_INFORMATION_MAP_INFO",
          payload: response?.routes[0]?.legs[0],
        });
      }
    }
  };


  useEffect(() => {
    if (
      loadPostState.loadPostInfo.origin_latitude &&
      loadPostState.loadPostInfo.destination_latitude &&
      map
    ) {
      let originLatLng_update = {
        lat: loadPostState.loadPostInfo.origin_latitude,
        lng: loadPostState.loadPostInfo.origin_longitude,
      };

      let destinationLatLng__update = {
        lat: loadPostState.loadPostInfo.destination_latitude,
        lng: loadPostState.loadPostInfo.destination_longitude,
      };

      google_map_direciton_service(
        originLatLng_update,
        destinationLatLng__update
      );
      setMapSelectionStart(true);
      userMarker && userMarker.setMap(null);
    };

  }, [loadPostState?.loadPostInfo?.origin_latitude, 
      loadPostState?.loadPostInfo?.destination_latitude, 
      map]);


  const setting_Route_Data = (data) => {
    originDrugChanged(data.start_location);
    handleDestinationClick(data.end_location);

    let direction_length = data.distance.text.split(" ")[0];

    if (data.distance.text.includes("mi")) {
      setTotalDistance(direction_length);
    } else {
      setTotalDistance((direction_length * 0.000189394).toFixed(4));
    }
  };

  const google_map_direciton_service = (first, second) => {
    directionsRenderer.setMap(map);

    directionsService
      .route({
        origin: first,
        destination: second,
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
        optimizeWaypoints: false,
      })
      .then((response) => {
        userMarker.setMap(null);
        directionsRenderer.setDirections(response);
        setting_Route_Data(response.routes[0].legs[0]);
      })
      .catch((e) => {});
  };


  const render = (status) => {
    if (status === Status.LOADING) return <h3>{status} ..</h3>;
    if (status === Status.FAILURE) return <h3>{status} ...</h3>;
    return null;
  };


  useEffect(() => {
    // init map
    if (mapRef && !map) {

      setMap(
        new google.maps.Map(mapRef, {
          center: currentLocation || DEFAULT_MAP_POSITION,
          zoom: 10,
        })
      );

      setDirectionsService(new google.maps.DirectionsService());
      setDirectionsRenderer(
        new google.maps.DirectionsRenderer({
          draggable: true,
          map,
        })
      );
    }
  }, [mapRef, google, map, currentLocation]);


  useEffect(() => {
    if (map && !isForUpdate) {
      var isMapSelected = true;
      map.addListener("click", (mapsMouseEvent) => {
        setMapSelectionStart(true);
        isMapSelected &&
        google_map_direciton_service(currentLocation, mapsMouseEvent.latLng);
        isMapSelected = false;
      });
    }
  }, [map, currentLocation, mapSelectionStart, isForUpdate]);


  useEffect(() => {
    if (map && directionsRenderer) {
      directionsRenderer.addListener("directions_changed", () => {
        const directions = directionsRenderer.getDirections();
        directions && setting_Route_Data(directions.routes[0].legs[0]);
        directions && directionsCallback(directions);
      });
    }
  }, [map, directionsRenderer]);


  useEffect(() => {

    if(loadPostInfo.origin_latitude && loadPostInfo.origin_longitude && map && userMarker !== null){
      userMarker.setPosition({
        lat : loadPostInfo.origin_latitude,
        lng : loadPostInfo.origin_longitude
      });

      var new_position = new google.maps.LatLng(loadPostInfo.origin_latitude,loadPostInfo.origin_longitude);
      map.setCenter(new_position);
      map.setZoom(10)
    };

  }, [loadPostInfo?.origin_latitude, loadPostInfo?.origin_longitude, map]);










  return (
    <section id="load-post-google-map">
      <div className="container theme-section">
        {loadPostInfo?.destination_latitude &&
        loadPostInfo?.destination_longitude ? (
          <h1>Drag and Drop To Change Origin And Destination Address By Map</h1>
        ) : (
          <h1>Select Your Origin And Destination Address By Map</h1>
        )}

        <div className="row">
          <div className="input-box-area col-md-6" single-labe="true">
            <label> Origin Latitude: {loadPostInfo?.origin_latitude}</label>
            <label> Origin Longitude: {loadPostInfo?.origin_longitude}</label>

            {errorMessages.origin_latitude?.length > 0 && (
              <div
                className="error"
                show-tittle="false"
                onMouseEnter={showErrorMessage}
                onMouseLeave={hideErrorMessage}
              >
                <i className="fa-solid fa-circle-exclamation"></i>
                {errorMessages.origin_latitude?.map((error, index) => (
                  <p key={shortid.generate()}>{error}</p>
                ))}
              </div>
            )}
          </div>

          <div className="input-box-area col-md-6" single-labe="true">
            <label>
              {" "}
              Destination Latitude: {loadPostInfo?.destination_latitude}
            </label>
            <label>
              {" "}
              Destination Longitude: {loadPostInfo?.destination_longitude}
            </label>

            {errorMessages.destination_latitude?.length > 0 && (
              <div
                className="error"
                show-tittle="false"
                onMouseEnter={showErrorMessage}
                onMouseLeave={hideErrorMessage}
              >
                <i className="fa-solid fa-circle-exclamation"></i>
                {errorMessages.destination_latitude?.map((error, index) => (
                  <p key={shortid.generate()}>{error}</p>
                ))}
              </div>
            )}
          </div>
        </div>

        <p>
          <b>From:</b> {directionsResponse?.routes[0]?.legs[0]?.start_address}
        </p>
        <p>
          <b>To</b>: {directionsResponse?.routes[0]?.legs[0]?.end_address}
        </p>
        <p>
          <b>Distance:</b> {totalDistance && totalDistance + " miles"}
        </p>
        <p>
          <b>Duration:</b> {directionsResponse?.routes[0]?.legs[0]?.duration.text}
        </p>
        <br></br>

        <Wrapper apiKey={GOOGLE_CLOUD_API_KEY} render={render}>
          <div ref={setMapRef} style={{ width: "100%", height: "500px" }} />
        </Wrapper>
      </div>
    </section>
  );
};

export default OriginDestinationSelectionMap
